import type { RouteRecordRaw } from 'vue-router';

export const orderPaymentRoutes: Array<RouteRecordRaw> = [
  {
    path: '/order/payment',
    name: 'orderPayment',
    redirect: '/order/payment/list',
    component: () => import('pages/central/pay/McPayment.vue'),
    meta: {
      title: 'Order Payment',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'orderPaymentList',
        component: () => import('pages/central/pay/PaymentList.vue'),
        meta: {
          title: 'Order Payment List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'orderPaymentDetail',
        component: () => import('pages/central/pay/PaymentDetail.vue'),
        meta: {
          title: 'Order Payment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'orderPaymentNew',
        component: () => import('pages/central/pay/PaymentNew.vue'),
        meta: {
          title: 'New Order Payment',
          requiresAuth: true,
        },
      },
    ],
  },
];
